import axios from 'axios'
import endpoints from '@/api/endpoints'


export default {
  async getPayrollReportData (from, to) {
    /*
      Gets the payroll data required for the main payroll report
      The two paramaters must have the format "YYYY-MM-DD"
    */
    return axios.get(endpoints.payrollReport + '?from_date=' + from + '&to_date=' + to).then((response) => {
      return response.data
    })
  }
}
